import { store } from "@/store/store";
import { VuexModule, Mutation, getModule, Module, Action } from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { WpProductoDto } from "@/shared/dtos/wordpress/wp-producto.dto";
import { WpPedidoDto } from "@/shared/dtos/wordpress/wp-pedido.dto";

@Module({ namespaced: true, name: "wordpressSuiteModule", store, dynamic: true })
class wordpressSuiteModule extends VuexModule {
    public productos: WpProductoDto[] = [];
    public pedidos: WpPedidoDto[] = [];
    public categorias: any[] = [];
    public totalProductos: number = 0;
    public totalPedidos: number = 0;

    @Action({ commit: "onGetProductos" })
    public async getProductos(params: { page: number; perPage: number; search: string; status: string }) {
        const qs = `page=${params.page}&perPage=${params.perPage}&search=${encodeURIComponent(params.search)}&status=${params.status}`;
        return await ssmHttpService.get(API.wordpressSuite + "productos?" + qs);
    }

    @Action({ commit: "onGetPedidos" })
    public async getPedidos(params: { page: number; perPage: number; status: string }) {
        const qs = `page=${params.page}&perPage=${params.perPage}&status=${params.status}`;
        return await ssmHttpService.get(API.wordpressSuite + "pedidos?" + qs);
    }

    @Action
    public async eliminarProducto(id: number) {
        await ssmHttpService.delete(API.wordpressSuite + "productos/" + id, null);
        this.context.commit("removeProducto", id);
    }

    @Action
    public async actualizarEstadoPedido(payload: { id: number; estado: string }) {
        await ssmHttpService.put(API.wordpressSuite + "pedidos/" + payload.id + "/estado", { estado: payload.estado });
    }

    @Action({ commit: "onGetCategorias" })
    public async getCategorias() {
        return await ssmHttpService.get(API.wordpressSuite + "categorias");
    }

    @Action
    public async crearProducto(payload: {
        name: string;
        description: string;
        regular_price: string;
        categories: Array<{ id: number }>;
        status: string;
    }) {
        return await ssmHttpService.post(API.wordpressSuite + "productos", payload);
    }

    @Action
    public async generarSEO(req: {
        titulo_original: string;
        descripcion: string;
        categoria: string;
        precio_amazon: number;
        precio_venta: number;
        asin: string;
    }) {
        return await ssmHttpService.post(API.wordpressSuiteGenerarSeo, req);
    }

    @Action
    public async actualizarProductoSeo(payload: { id: number; nombre: string; descripcion: string; short_description: string }) {
        return await ssmHttpService.put(API.wordpressSuite + "productos/" + payload.id + "/seo", payload);
    }

    @Mutation
    public onGetProductos(res: any) {
        this.totalProductos = res ? Number(res.total) || 0 : 0;
        this.productos = res && res.items ? res.items.map((x: any) => new WpProductoDto(x)) : [];
    }

    @Mutation
    public onGetPedidos(res: any) {
        this.totalPedidos = res ? Number(res.total) || 0 : 0;
        this.pedidos = res && res.items ? res.items.map((x: any) => new WpPedidoDto(x)) : [];
    }

    @Mutation
    public onGetCategorias(res: any[]) {
        this.categorias = res || [];
    }

    @Mutation
    public removeProducto(id: number) {
        this.productos = this.productos.filter((p: WpProductoDto) => p.id !== id);
        this.totalProductos = Math.max(0, this.totalProductos - 1);
    }
}

export default getModule(wordpressSuiteModule);
